module.exports = __webpack_public_path__ + "img/personal.0157fd95.svg";